// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ids-popup::part(popup) {
  padding-block: 0;
}

ids-popup[visible][animated] {
  transition: none;
}

.ids-date-picker-popup .ids-popup.menu {
  padding-block: 0;
}

ids-month-view {
  width: 100%;
}

#month-year-view-trigger {
  margin: 4px;
}

.ids-date-picker-popup {
  min-width: 350px;
}
.ids-date-picker-popup:not(.has-time) ids-month-view::part(table-container) {
  margin-bottom: 10px;
}
.ids-date-picker-popup ids-popup::part(popup) {
  padding-block: 0;
}
.ids-date-picker-popup .popup-footer {
  border-top: 1px solid var(--ids-date-picker-popup-footer-color-border);
  display: flex;
}
.ids-date-picker-popup .popup-footer ids-modal-button:not([hidden]) + ids-modal-button,
.ids-date-picker-popup .popup-footer .ids-modal-button:not([hidden]) + .ids-modal-button {
  border-left: 1px solid;
  border-left-color: var(--ids-date-picker-popup-footer-color-border);
}
.ids-date-picker-popup .popup-btn {
  width: 100%;
}

.ids-date-picker-content {
  position: relative;
}

ids-expandable-area {
  display: block;
}

ids-expandable-area:not([expanded]),
ids-expandable-area[expanded=false] {
  pointer-events: none;
}

ids-expandable-area::part(container) {
  margin: 0;
  padding: 0;
  height: 100%;
  position: absolute;
  z-index: 3;
  border: none;
  left: 0;
  width: 100%;
}

ids-expandable-area::part(header) {
  display: none;
}

ids-expandable-area::part(pane) {
  background-color: var(--ids-date-picker-color-background);
}

ids-expandable-area::part(footer) {
  display: none;
}

ids-expandable-area::part(pane-content) {
  margin-top: 0;
  height: 100%;
}

ids-time-picker-popup {
  display: flex;
  justify-content: center;
}
ids-time-picker-popup[hidden] {
  display: none;
}
ids-time-picker-popup[embeddable] {
  margin-top: -18px;
}

.btn-today {
  margin-right: -7px;
}
.btn-today::part(button) {
  padding: 8px;
  margin: 3px;
}

.btn-today-text {
  color: var(--ids-date-picker-popup-button-today-color-text);
}

.btn-previous,
.btn-next {
  padding-inline-start: 0;
  margin: 3px;
}
.btn-previous::part(button),
.btn-next::part(button) {
  padding: 0;
  width: 38px;
  height: 38px;
}

.btn-next {
  margin: 3px 3px 3px -5px;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-date-picker/ids-date-picker-popup.scss"],"names":[],"mappings":"AACA;EACE,gBAAA;AAAF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,gBAAA;AADF;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,gBAAA;AAFJ;AAKE;EACE,sEAAA;EACA,aAAA;AAHJ;AAKI;;EAEE,sBAAA;EACA,mEAAA;AAHN;AAOE;EACE,WAAA;AALJ;;AASA;EACE,kBAAA;AANF;;AAYA;EACE,cAAA;AATF;;AAYA;;EAEE,oBAAA;AATF;;AAYA;EACE,SAAA;EACA,UAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,yDAAA;AATF;;AAYA;EACE,aAAA;AATF;;AAYA;EACE,aAAA;EACA,YAAA;AATF;;AAeA;EACE,aAAA;EACA,uBAAA;AAZF;AAcE;EACE,aAAA;AAZJ;AAeE;EACE,iBAAA;AAbJ;;AAoBA;EACE,kBAAA;AAjBF;AAmBE;EACE,YAAA;EACA,WAAA;AAjBJ;;AAqBA;EACE,2DAAA;AAlBF;;AAqBA;;EAEE,uBAAA;EACA,WAAA;AAlBF;AAoBE;;EACE,UAAA;EACA,WAAA;EACA,YAAA;AAjBJ;;AAqBA;EACE,wBAAA;AAlBF","sourcesContent":["// Date Picker Popup padding reset\nids-popup::part(popup) {\n  padding-block: 0;\n}\n\n// Remove left/top transforms from animation on this component's popup\nids-popup[visible][animated] {\n  transition: none;\n}\n\n.ids-date-picker-popup .ids-popup.menu {\n  padding-block: 0;\n}\n\nids-month-view {\n  width: 100%;\n}\n\n#month-year-view-trigger {\n  margin: 4px;\n}\n\n.ids-date-picker-popup {\n  min-width: 350px;\n\n  &:not(.has-time) ids-month-view::part(table-container) {\n    margin-bottom: 10px;\n  }\n\n  ids-popup::part(popup) {\n    padding-block: 0;\n  }\n\n  .popup-footer {\n    border-top: 1px solid var(--ids-date-picker-popup-footer-color-border);\n    display: flex;\n\n    ids-modal-button:not([hidden]) + ids-modal-button,\n    .ids-modal-button:not([hidden]) + .ids-modal-button {\n      border-left: 1px solid;\n      border-left-color: var(--ids-date-picker-popup-footer-color-border);\n    }\n  }\n\n  .popup-btn {\n    width: 100%;\n  }\n}\n\n.ids-date-picker-content {\n  position: relative;\n}\n\n// =====================================\n// IdsExpandableArea\n\nids-expandable-area {\n  display: block;\n}\n\nids-expandable-area:not([expanded]),\nids-expandable-area[expanded='false'] {\n  pointer-events: none;\n}\n\nids-expandable-area::part(container) {\n  margin: 0;\n  padding: 0;\n  height: 100%;\n  position: absolute;\n  z-index: 3;\n  border: none;\n  left: 0;\n  width: 100%;\n}\n\nids-expandable-area::part(header) {\n  display: none;\n}\n\nids-expandable-area::part(pane) {\n  background-color: var(--ids-date-picker-color-background);\n}\n\nids-expandable-area::part(footer) {\n  display: none;\n}\n\nids-expandable-area::part(pane-content) {\n  margin-top: 0;\n  height: 100%;\n}\n\n// =====================================\n// Timepicker\n\nids-time-picker-popup {\n  display: flex;\n  justify-content: center;\n\n  &[hidden] {\n    display: none;\n  }\n\n  &[embeddable] {\n    margin-top: -18px;\n  }\n}\n\n// =====================================\n// Footer buttons\n\n.btn-today {\n  margin-right: -7px;\n\n  &::part(button) {\n    padding: 8px;\n    margin: 3px;\n  }\n}\n\n.btn-today-text {\n  color: var(--ids-date-picker-popup-button-today-color-text);\n}\n\n.btn-previous,\n.btn-next {\n  padding-inline-start: 0;\n  margin: 3px;\n\n  &::part(button) {\n    padding: 0;\n    width: 38px;\n    height: 38px;\n  }\n}\n\n.btn-next {\n  margin: 3px 3px 3px -5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
